import React from "react";
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';
import PageAncestor from "core/common/page/pageAncestor";
import Toolmenu from "core/components/toolmenu/toolmenu";
import {ZzIconButtonRoute} from "core/components/buttons/icons";
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import mdEntityService from "core/metamodel/mdEntityService";
import Grid from 'core/grid/domain/grid';
import {TabTemplate} from "core/common/config/mui-theme";
import {ErrorComp} from "core/components/errorComp/errorComp";
import {preSave, IDomainObject} from "core/form/formUtils";
import gridService from "core/grid/gridService";
import GridComp from "core/grid/component/gridComp";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import eventService from "core/event/eventService";
import EventTypeForm from "core/event/component/eventTypeForm";
import {tabStyle} from 'core/common/config/variables';
import Add from "material-ui/svg-icons/content/add";
import {MODULE, PERMISSION, SECURABLE_TYPE, PageProps} from "core/metamodel/metaConstant";
import {EventType} from "core/event/eventDomain";
import {MovingBlocks, GridComposite, Movable} from "core/grid/gridUtils";
import uiService from "core/common/service/uiService";
import {observer} from "mobx-react";
import {action} from "mobx";
import {GridCompositeComp} from "core/grid/component/gridComp";
import {
  getSelectTenant, getSelectTenantGroup, setSelectTenant,
  setSelectTenantGroup
} from "core/tenant/tenantSelectionSupport";
import {loc} from "../common/config/locales";




const eventTemplateGridLocation = 'eventTemplateList';
const tenantGridComposite = 'tenantGridComposite';
const tenantGridLocation = 'tenantList';
const tenantGroupListLocation = 'tenantGroupList';

@observer
export default class EventTypeDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Event Type';
  static icon = 'send';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("EventTypeDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['EventType']);

    let eventPromise: Promise<EventType>;

    if (routerParams.id === 'new') {
      eventPromise = Promise.resolve(new EventType({$new: true}));
    } else {
      eventPromise = eventService.readEventType(routerParams.id);
    }

    let gridPromise = gridService.fetchGrids(eventTemplateGridLocation, tenantGridLocation, tenantGroupListLocation);

    return Promise.all([metadataPromise, eventPromise, gridPromise])
      .then(([entityMap, eventTypeObject, gridLocationMap]: [any, EventType, any]) => {

        eventTypeObject.$movingBlocks = new MovingBlocks(tenantGridComposite, true, query.tab,
          new Grid(gridLocationMap.get(eventTemplateGridLocation), eventTypeObject.eventTypeId),
          new GridComposite(tenantGridComposite, 'Tenant selection', new Grid(gridLocationMap.get(tenantGridLocation)),
                          new Grid(gridLocationMap.get(tenantGroupListLocation)))
           );

        eventService.eventTypeObject = eventTypeObject.initAfterRead(false);
      });
  }



  componentWillMount() {
    uiService.addMediaQueryListener(this.mediaQueryListener);
  }


  /**
   * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    if(this.idChanged(prevProps.params.id, this.props.params.id)) {
      eventService.eventTypeObject.$movingBlocks.searchExposedGrids(eventService.eventTypeObject);
    }
  }

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    eventService.eventTypeObject.$movingBlocks.searchExposedGrids(eventService.eventTypeObject);
  }

  componentWillUnmount() {
    uiService.removeMediaQueryListener(this.mediaQueryListener);
    eventService.eventTypeObject = null;
  }



  customValidate = (eventTypeObject) => {
    let errors = [];

    return errors;
  };


  findRootObject() {
    return eventService.eventTypeObject;
  }



  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();

    let result = preSave(eventService.eventTypeObject, this.customValidate);
    if (!result) {
      return;
    }


    eventService.saveEventType(eventService.eventTypeObject)
      .then( action("eventSave-callback", (eventTypeJson: IDomainObject) => {
        let wasNew = eventService.eventTypeObject.cleanAfterSave(eventTypeJson);
        if (wasNew) {
          this.context.router.replaceWith('eventTypeDetail', {id: eventService.eventTypeObject.eventTypeId});
        }
        uiService.hideToolbarActionFlag();
      }), error => {
        eventService.eventTypeObject.$errors = error.getMessages();
      });

  };



  onAdd = (evt) => {
    console.log('onAdd');
    this.context.router.transitionTo("eventTypeDetail", {id: 'new'});
  };


  @action onDelete = (evt) => {
    console.log('onDelete');

    eventService.deleteEventType(eventService.eventTypeObject.eventTypeId)
      .then(response => {
        this.context.router.transitionTo('eventTypeList');
      }, error => {
        eventService.eventTypeObject.$errors = error.getMessages();
      });
  };




  render() {

    let {
      query
    } = this.props;


    const propsForCreateForm = {
      dataObject: eventService.eventTypeObject,
      rootObject: eventService.eventTypeObject,
      entity: mdEntityService.getEntity('EventType'),
      entities: mdEntityService.entityMap
    };

    console.debug('%c eventTypeDetail render query %O', 'background-color: yellow', this.props.query);


    const mainForm = (
      <form style={{marginTop: 10}}>
        <div className="row">
          <div className="col-xs-12">
            <EventTypeForm {...propsForCreateForm} />
          </div>
        </div>
      </form>
    );


    let movingBlocks = eventService.eventTypeObject.$movingBlocks;

    const gridCompArray = [
      <GridComp grid={movingBlocks.getBlock(eventTemplateGridLocation) as Grid}
                uiLocation={movingBlocks.getUiLocation(eventTemplateGridLocation)}
                 entities={mdEntityService.entityMap}>
        <ZzIconButtonRoute big routeName="eventTemplateDetail" params={{id: 'new'}} query={eventService.eventTypeObject.createLov()}
                           securable="eventTemplateDetail" permission={PERMISSION.New}>
          <Add/>
        </ZzIconButtonRoute>
      </GridComp>,
      <GridCompositeComp grid={movingBlocks.getBlock(tenantGridComposite) as GridComposite} uiLocation={movingBlocks.getUiLocation(tenantGridComposite)} >
        <div className="col-xs-12 col-sm-6" style={{padding: 10}}>
          <h4>Select Tenants</h4>
          <GridComp grid={(movingBlocks.getBlock(tenantGridComposite) as GridComposite).groupMembers[0]} multiSelect={false} hideToolbar={true} gridClassName="detail-grid"
                    uiLocation={movingBlocks.getUiLocation(tenantGridComposite)} functionMap={{getSelectTenant: getSelectTenant.bind(this, eventService.eventTypeObject), setSelectTenant: setSelectTenant.bind(this, eventService.eventTypeObject)}}
                    entities={mdEntityService.entityMap} />
        </div>
        <div className="col-xs-12 col-sm-6" style={{padding: 10}}>
          <h4>or select Tenant Groups</h4>
          <GridComp grid={(movingBlocks.getBlock(tenantGridComposite) as GridComposite).groupMembers[1]} multiSelect={false} hideToolbar={true} gridClassName="detail-grid"
                    uiLocation={movingBlocks.getUiLocation(tenantGridComposite)} functionMap={{getSelectTenantGroup: getSelectTenantGroup.bind(this, eventService.eventTypeObject), setSelectTenantGroup: setSelectTenantGroup.bind(this, eventService.eventTypeObject)}}
                    entities={mdEntityService.entityMap} />
        </div>
      </GridCompositeComp>
    ];

    const standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);

    const tabArray = gridCompArray.map(gridComp => (
      <Tab label={gridComp.props.grid.label} style={tabStyle} onActive={this.activateTab.bind(this, gridComp.props.grid)} key={gridComp.props.grid.getBlockName()}  value={gridComp.props.grid.getBlockName()}>
        {gridComp}
      </Tab>
    ));


    const tabs = (tabArray.length) ? (
      <Tabs value={movingBlocks.activeBlockTab} className="detail-grid" tabTemplate={TabTemplate} inkBarStyle={{transition: 'inherit'}}
            contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: 0}} onChange={this.onTabChange}>
        {tabArray}
      </Tabs>
    ) : '';



    if (uiService.globalMediaQuery.matches) {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'row'}} >
          <div style={{display: 'flex', flexDirection: 'column', height: '100%', width:'50%'}}>
            {this._createToolMenu(eventService.eventTypeObject, query.gridLocation)}
            <ErrorComp messages={eventService.eventTypeObject.$errors} />
            <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
            <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
            {mainForm}
            {tabs}
          </div>
          {standAloneGridComp}
        </main>
      );
    } else {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'column'}} >
          {this._createToolMenu(eventService.eventTypeObject, query.gridLocation)}
          <ErrorComp messages={eventService.eventTypeObject.$errors} />
          <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
          <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
          {mainForm}
          {tabs}
        </main>
      );
    }
  }


  _createToolMenu(eventTypeObject, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1} activeTab={eventTypeObject.$movingBlocks.activeBlockTab}>
        <ZzFlatButton onClick={this.onSave} disabled={!eventTypeObject.$dirty} label="Save" permission={eventTypeObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.onAdd} disabled={eventTypeObject.$new} label="New" permission={PERMISSION.New}/>
        <WithDeleteDialogZzFlatButton entityName="EventType" pageAncestor={this} onClick={this.onDelete} disabled={eventTypeObject.$new} label="Delete" permission={PERMISSION.Delete}/>

      </Toolmenu>
    );
  }




}




// WEBPACK FOOTER //
// ./src/core/event/eventTypeDetail.tsx